import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { CustomerSuccessMappingBundleService } from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Dtos_CustomerSuccess_UpsertCustomerSuccessMappingBundleDto } from '@wealthlane/api-services/wealthlane-identity-service';

const usePostCustomerSuccessMappingBundle = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Wealthlane_Dtos_CustomerSuccess_UpsertCustomerSuccessMappingBundleDto
> => {
  return useMutation(
    async (payload) => {
      return await handleRequest(
        CustomerSuccessMappingBundleService.postApiIdentityApiAppCustomerSuccessManage(payload)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          toast.success(
            <ToastComponent
              label='Success'
              message={response.message ?? 'Customer Success Automation saved successfully.'}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCustomerSuccessMappingBundle;
